// Copyright (c) 2022 by Move Closer

import { ModulesUiRegistryEntry } from '../../../contexts'

import { resolveArticlesTeaserBoxModuleContent } from '../ArticlesTeaserBox.helpers'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const articleTeaserBoxModule: ModulesUiRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "ui/core/articles-teaser-box" */ './ArticlesTeaserBox.ui.vue'
  ),
  resolver: resolveArticlesTeaserBoxModuleContent
}
